import { render } from "./LogHistory.vue?vue&type=template&id=31cdfe13&scoped=true"
import script from "./LogHistory.vue?vue&type=script&lang=js"
export * from "./LogHistory.vue?vue&type=script&lang=js"

import "./LogHistory.vue?vue&type=style&index=0&id=31cdfe13&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31cdfe13"]])

export default __exports__